module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-bracket-perfetto_secondary-24843622a67f495566949a9fcef7034c.png";